<div class="item-container">
  <div class="item-header">
    <h5 class="text-center">{{"COMMON.ADD" | translate}} Location</h5>
    <div class="edit-icons" (click)="onCancel()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content shift-container">
    <div class="mt-3" *ngIf="userType=='recruiter'">
      <div class="mt-3  d-flex align-items-center flex-wrap flex-md-nowrap">
        <label for="" class="flex-grow-1 mb-0 flex-shrink-0 me-3 label-item">Company Name:</label>
        <mat-select class="form-control" placeholder="Select Company" [(ngModel)]="companyId">
          <mat-option *ngFor="let item of companyArr" [value]="item.co_i">{{item.company_name}}</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="mt-3 d-flex align-items-center flex-wrap flex-md-nowrap">
      <label for="" class="flex-grow-1 mb-0 flex-shrink-0 me-3 label-item">Property Name:</label>
      <input type="text" #property class="form-control" placeholder="Enter Property name">
    </div>
    <div class="mt-3 d-flex align-items-center flex-wrap flex-md-nowrap">
      <label for="" class="flex-grow-1 mb-0 flex-shrink-0 me-3 label-item">Search Location:</label>
      <input type="text" #search class="form-control" placeholder="Search Location">
    </div>
    <div>
      <div class="mt-3">
        <agm-map [latitude]="latitude" [longitude]="longitude">
          <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true" (dragEnd)="markerDragEnd($event)"></agm-marker>
        </agm-map>
        <div class="mt-lg-4">
          <h6 *ngIf="address">Address: {{address}}</h6>
        </div>
      </div>
    </div>
  </div>
  <div>
    <mat-error *ngIf="errorMsg">{{errorMsg}}</mat-error>
  </div>
  <div class="row">
    <div class="col-md-6 m-auto">
      <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit" (click)="onSubmit()">
        {{ "BUTTON.SAVE" | translate }}</button>
    </div>
  </div>
</div>